import strapiApi from "../utils/strapiApi";
import { HELP_CONTENT, BANNER_CONTENT, ACCOUNT_NOTIFICATION } from "./contentRoutes";

export const getHelpContentData = async () => strapiApi.get(HELP_CONTENT);
export const getBannerContentData = async () => strapiApi.get(BANNER_CONTENT);
export const getAccountNotificationsContentData = async () => strapiApi.get(ACCOUNT_NOTIFICATION);

